import React from "react"

interface Props {
  changeColorOnActive?: boolean
  isActive?: boolean
  activeColor?: string
}

const IconFilter: React.FC<Props> = ({
  changeColorOnActive,
  isActive,
  activeColor,
}) => {
  const defaultStrokeColor = "#242424"
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="0.875"
        width="16"
        height="16"
        rx="8"
        fill={
          changeColorOnActive && isActive && activeColor
            ? activeColor
            : defaultStrokeColor
        }
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.51534 7.32463C4.51534 6.96787 4.79752 6.66856 5.18715 6.66792C5.57682 6.66723 5.82853 6.66856 5.82853 6.66856C5.82853 6.66856 5.81179 6.2873 5.81179 5.98409C5.81179 5.68079 6.0805 5.37728 6.47039 5.37728C6.86028 5.37728 10.4751 5.36614 10.8417 5.39313C11.2082 5.42012 11.5 5.649 11.5 6.01716C11.5 6.38531 11.4977 10.0357 11.4977 10.3738C11.4977 10.7119 11.1921 11.0191 10.8133 11.0234C10.4346 11.0276 10.1778 11.0191 10.1778 11.0191C10.1778 11.0191 10.1918 11.4462 10.1918 11.7085C10.1918 11.9708 9.88452 12.3518 9.52402 12.3518C9.16352 12.3518 5.50575 12.375 5.15672 12.375C4.8077 12.375 4.48561 12.0702 4.5005 11.6901C4.51538 11.3101 4.51538 7.68131 4.51538 7.32463H4.51534ZM6.50297 6.10429L6.50003 10.3095C6.50003 10.3564 6.53861 10.3947 6.5863 10.3945L10.7098 10.3726C10.7327 10.3725 10.7547 10.3634 10.7708 10.3473C10.787 10.3311 10.796 10.3093 10.796 10.2865L10.7932 6.11907C10.7932 6.09626 10.7841 6.07439 10.7678 6.05827C10.7515 6.04215 10.7295 6.03309 10.7065 6.03309L6.58971 6.01913C6.57836 6.01901 6.56711 6.02113 6.5566 6.02536C6.54609 6.02959 6.53652 6.03584 6.52846 6.04376C6.52039 6.05168 6.51399 6.06111 6.50961 6.07149C6.50524 6.08188 6.50298 6.09303 6.50297 6.10429ZM5.1824 7.49899L5.22193 11.622C5.22221 11.6447 5.23154 11.6664 5.24787 11.6823C5.26421 11.6982 5.28622 11.7071 5.3091 11.7069L9.37087 11.6763C9.3935 11.6762 9.41589 11.6716 9.43673 11.6629C9.45757 11.6541 9.47647 11.6413 9.49232 11.6253C9.50818 11.6093 9.52068 11.5903 9.52912 11.5694C9.53755 11.5486 9.54174 11.5263 9.54146 11.5038L9.53555 11.0267C9.53555 11.0267 6.82221 11.0515 6.46935 11.0515C6.11649 11.0515 5.80316 10.7199 5.80316 10.3468C5.80316 9.97368 5.82853 7.4038 5.82853 7.4038C5.82896 7.35668 5.79081 7.31855 5.74326 7.31919L5.35372 7.32476C5.30775 7.32538 5.2639 7.34407 5.23179 7.37673C5.19968 7.40939 5.18192 7.45335 5.1824 7.49899Z"
        fill="white"
      />
    </svg>
  )
}

export default IconFilter
